<template>
  <div>
    <div class="px-2 py-1 mb-4"
         style="height: 200px; overflow-y: scroll; border: 1px solid #EFEFEF; font-size: 15px">
        <h3 style="text-align: center">Consentement – Programme SALUTANCE –</h3>
        <h4 style="text-align: center; margin-bottom: 30px">Mission « Pour mieux vous connaître »</h4>

      <p>
        Dans le cadre de la mission « Pour mieux vous connaître », nous allons recueillir des données à caractère personnel : votre âge, votre poids, votre taille, votre sexe et votre catégorie socio-professionnelle.<br/>
        Ces données sont collectées par VIASANTE Mutuelle, membre du groupe AG2R LA MONDIALE et traitées par la société IRIADE dans le cadre du programme SALUTANCE.<br/>
        Les données collectées par SALUTANCE sont hébergées en France, par la société COREYE-PICTIME  50 rue Paradis, 75010 Paris, qui possède l’agrément HADS SILVER SANTE, obtenu auprès de l'ASIP Santé, pour l'hébergement des données de santé.
      </p>

      <p>
        Les données personnelles collectées et traitées dans le cadre de cette mission sont strictement confidentielles et sont consultables seulement par l’équipe de Coachs qui vous encadre. VIASANTE Mutuelle ne pourra en aucun cas y accéder ou les céder à des tiers.
      </p>

      <p>
        Vos données pourront être traitées à des fins statistiques pour améliorer nos prestations : dans ce cas, elles seront anonymisées et ne permettront pas votre identification.
      </p>

      <p>
        Conformément à la loi « Informatique et Libertés » du 6 janvier 1978 modifiée, vous pouvez accéder aux données vous concernant, les rectifier, demander leur effacement ou exercer votre droit à la limitation du traitement de vos données, Vous pouvez, à tout moment, retirer votre consentement au traitement de vos données à caractère personnel...
      </p>

      <p>
        Ces droits peuvent être exercés en adressant un courrier accompagné d’un justificatif d’identité à à VIASANTE Mutuelle, à l’attention du Délégué à la protection des données (DPD) - 1 avenue Carsalade du Pont - CS 89921 - 66866 PERPIGNAN cedex 9 ou par voie électronique à DPD@viasante.fr.
      </p>

      <p>
        Les données ne peuvent être conservées que pour une durée n’excédant pas la durée nécessaire à la finalité du traitement. Pour déterminer ces délais, VIASANTE Mutuelle s’est servi des règles issues de recommandations de la CNIL, d’obligations règlementaires ou des délais légaux de prescription des éventuelles actions en justice applicables.
      </p>

      <p>
        Les données nécessaires au suivi du programme SALUTANCE et des services associés sont conservées pendant toute la durée de votre participation au programme et jusqu’à expiration des délais de prescriptions légales.
      </p>

      <p>
        Pour en savoir plus sur notre politique de protection de la vie privée et des données à caractère personnel, retrouvez des explications complémentaires sur le site internet de VIASANTE Mutuelle https://www.mutuelle-viasante.fr/protection-vie-privee
      </p>

      <p>
        Aucune information personnelle de l'utilisateur du site salutance.iriade.fr n'est publiée à l'insu de l'utilisateur, échangée, transférée, cédée ou vendue sur un support quelconque à des tiers. Seule l'hypothèse du rachat de la société IRIADE et de ses droits permettrait la transmission desdites informations à l'éventuel acquéreur qui serait à son tour tenu de la même obligation de conservation et de modification des données vis-à-vis de l'utilisateur du site salutance.iriade.fr
      </p>

      <p>
        SALUTANCE est un télécoaching numérique édité par : VIASANTÉ Mutuelle, la mutuelle d’AG2R LA MONDIALE et les Ateliers du devenir, une association régie par la loi du 1er juillet 1901 et créée par des professionnels de santé.<br/>
        SALUTANCE est mis en ligne par la société IRIADE - 10 rue Bossuet 31400 TOULOUSE - contact@iriade.fr, sur la solution logicielle en ligne « Iriade Télésuivi ».
      </p>
    </div>

    <IriadeRadioGroup ref="radioGroup"
                      :label="input.label"
                      :options="input.config.options"
                      :lambda="computLambda"
                      v-on="$listeners"
                      :error-messages="errors"></IriadeRadioGroup>

    <p class="primary--text" style="font-style: italic">Si vous ne donnez pas votre consentement, les données entrées dans le formulaire ci-dessous ne seront pas enregistrées.</p>
  </div>
</template>

<script>
  import IriadeFormBlockMixin from './IriadeFormBlockMixin'

  export default {
    mixins: [IriadeFormBlockMixin],
  }
</script>
